module.exports = __webpack_public_path__ + "img/header.f57fbc7.jpg";